module.exports = __webpack_public_path__ + "static/media/icon_file-CSV_plano-512.79c71dbc.webp";